// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skeleton {
  background-color: #e0e0e0;
  border-radius: 4px;
  animation: pulse 1.5s infinite;
}

.blog-para{
  font-size: 35px;
  font-weight: 700;
}

.explore-head{
  color: #092642;
  font-weight: 600;
  max-width: 600px;
  font-size: 32px;
  text-align: center;
  margin: 0 auto 16px;
}

.book-head{
  color: #092642;
  font-weight: 600;
  max-width: 600px;
  font-size: 32px;
  text-align: center;
  margin: 0 auto 16px;
}

.text-para{
  font-size: 16px;
  font-weight: 500;
  color: #495E76;
}

@keyframes pulse {
  0% {
    opacity: 0.9;
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 0.9;
  }
}

/* Breadcrumb */
.breadcrumb-list {
  padding: 2rem 1rem;
  /* text-align: center; */
}

@keyframes pulse {
  0% {
    background-color: #e0e0e0;
  }

  50% {
    background-color: #f0f0f0;
  }

  100% {
    background-color: #e0e0e0;
  }
}

.breadcrumb ol {
  flex-wrap: wrap;
  /* justify-content: center; */
}

@media (max-width: 768px) {
  .breadcrumb h1 {
    font-size: 24px;
  }
}


@media (max-width: 1200px) {
  .blogcards {
    padding-right: 100px;
    padding-left: 100px;
  }
}

@media (max-width: 992px) {
  .blogcards {
    padding-right: 60px;
    padding-left: 60px;
  }
}

@media (max-width: 768px) {
  .blogcards {
    padding-right: 20px;
    padding-left: 20px;
  }

  .blog-card {
    font-size: 14px;
    margin-bottom: 20px;
  }
}

@media (max-width: 576px) {
  .blogcards {
    padding-right: 10px;
    padding-left: 10px;
  }
}

/* Blog Card */
.blog-card {
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
}

.blog-card:hover {
  transform: translateY(-6px);
  background-color: #f8fafc;
  box-shadow: 0 20px 44px rgba(15, 23, 42, 0.10);
}

.blog-hero {
  padding-bottom: clamp(1.5rem, 3vw, 2rem);
}

.blogcards {
  padding-top: 0.5rem;
}

.blog-card img {
  width: 100%;
  height: auto;
  max-height: 250px;
  object-fit: cover;
  transition: transform 0.4s ease;
}

.blog-card:hover img {
  transform: scale(1.05);
}

.blog-card .card-body {
  position: relative;
}

/* Pagination Styles */
.page-link.green-page {
  background-color: #eafaf1;
  border: 1px solid #a8e4b8;
  color: #28a745;
  margin: 0 5px;
  border-radius: 50px;
  width: 40px;
  height: 40px;
  text-align: center;
  padding: 6px 0;
  font-weight: bold;
}

.page-link.green-page:hover,
.page-link.green-page.active-green {
  background-color: #28a745;
  color: white;
  border-color: #28a745;
}

/* General Pagination */
.pagination .page-item .page-link {
  width: 40px;
  height: 40px;
  line-height: 38px;
  text-align: center;
  padding: 0;
  border-radius: 50%;
  margin: 0 6px;
  background-color: white;
  transition: all 0.3s ease;
  font-weight: 500;
}

.pagination .page-item .page-link:hover {
  background-color: #097E52;
  color: white;
  border-color: #097E52;
}

.pagination .page-item.active .page-link {
  background-color: #097E52;
  color: white;
  border-color: #097E52;
}

.pagination .page-item.disabled .page-link {
  background-color: #f8f9fa;
  color: #ccc;
  border-color: #dee2e6;
  cursor: not-allowed;
}

/* Featured Post Image */
.featured-post img {
  max-height: 400px;
  object-fit: cover;
}`, "",{"version":3,"sources":["webpack://./src/css/blog.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;;AAGA;EACE;IACE,oBAAoB;IACpB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,iBAAiB;AACnB","sourcesContent":[".skeleton {\n  background-color: #e0e0e0;\n  border-radius: 4px;\n  animation: pulse 1.5s infinite;\n}\n\n.blog-para{\n  font-size: 35px;\n  font-weight: 700;\n}\n\n.explore-head{\n  color: #092642;\n  font-weight: 600;\n  max-width: 600px;\n  font-size: 32px;\n  text-align: center;\n  margin: 0 auto 16px;\n}\n\n.book-head{\n  color: #092642;\n  font-weight: 600;\n  max-width: 600px;\n  font-size: 32px;\n  text-align: center;\n  margin: 0 auto 16px;\n}\n\n.text-para{\n  font-size: 16px;\n  font-weight: 500;\n  color: #495E76;\n}\n\n@keyframes pulse {\n  0% {\n    opacity: 0.9;\n  }\n\n  50% {\n    opacity: 0.5;\n  }\n\n  100% {\n    opacity: 0.9;\n  }\n}\n\n/* Breadcrumb */\n.breadcrumb-list {\n  padding: 2rem 1rem;\n  /* text-align: center; */\n}\n\n@keyframes pulse {\n  0% {\n    background-color: #e0e0e0;\n  }\n\n  50% {\n    background-color: #f0f0f0;\n  }\n\n  100% {\n    background-color: #e0e0e0;\n  }\n}\n\n.breadcrumb ol {\n  flex-wrap: wrap;\n  /* justify-content: center; */\n}\n\n@media (max-width: 768px) {\n  .breadcrumb h1 {\n    font-size: 24px;\n  }\n}\n\n\n@media (max-width: 1200px) {\n  .blogcards {\n    padding-right: 100px;\n    padding-left: 100px;\n  }\n}\n\n@media (max-width: 992px) {\n  .blogcards {\n    padding-right: 60px;\n    padding-left: 60px;\n  }\n}\n\n@media (max-width: 768px) {\n  .blogcards {\n    padding-right: 20px;\n    padding-left: 20px;\n  }\n\n  .blog-card {\n    font-size: 14px;\n    margin-bottom: 20px;\n  }\n}\n\n@media (max-width: 576px) {\n  .blogcards {\n    padding-right: 10px;\n    padding-left: 10px;\n  }\n}\n\n/* Blog Card */\n.blog-card {\n  overflow: hidden;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.blog-card:hover {\n  transform: translateY(-6px);\n  background-color: #f8fafc;\n  box-shadow: 0 20px 44px rgba(15, 23, 42, 0.10);\n}\n\n.blog-hero {\n  padding-bottom: clamp(1.5rem, 3vw, 2rem);\n}\n\n.blogcards {\n  padding-top: 0.5rem;\n}\n\n.blog-card img {\n  width: 100%;\n  height: auto;\n  max-height: 250px;\n  object-fit: cover;\n  transition: transform 0.4s ease;\n}\n\n.blog-card:hover img {\n  transform: scale(1.05);\n}\n\n.blog-card .card-body {\n  position: relative;\n}\n\n/* Pagination Styles */\n.page-link.green-page {\n  background-color: #eafaf1;\n  border: 1px solid #a8e4b8;\n  color: #28a745;\n  margin: 0 5px;\n  border-radius: 50px;\n  width: 40px;\n  height: 40px;\n  text-align: center;\n  padding: 6px 0;\n  font-weight: bold;\n}\n\n.page-link.green-page:hover,\n.page-link.green-page.active-green {\n  background-color: #28a745;\n  color: white;\n  border-color: #28a745;\n}\n\n/* General Pagination */\n.pagination .page-item .page-link {\n  width: 40px;\n  height: 40px;\n  line-height: 38px;\n  text-align: center;\n  padding: 0;\n  border-radius: 50%;\n  margin: 0 6px;\n  background-color: white;\n  transition: all 0.3s ease;\n  font-weight: 500;\n}\n\n.pagination .page-item .page-link:hover {\n  background-color: #097E52;\n  color: white;\n  border-color: #097E52;\n}\n\n.pagination .page-item.active .page-link {\n  background-color: #097E52;\n  color: white;\n  border-color: #097E52;\n}\n\n.pagination .page-item.disabled .page-link {\n  background-color: #f8f9fa;\n  color: #ccc;\n  border-color: #dee2e6;\n  cursor: not-allowed;\n}\n\n/* Featured Post Image */\n.featured-post img {\n  max-height: 400px;\n  object-fit: cover;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
